<template>
    <q-page>
        <div class="q-pa-md row items-start q-gutter-md row">
            <q-card class="my-card full-width">
                <div>
                    <h4 class="text-h4">
                        <q-icon name="fas fa-chalkboard-teacher" class="q-pl-md q-pr-xs"></q-icon>
                        {{ live_class.title }}
                    </h4>
                </div>

                <q-card-separator />

                <q-card-main class="row q-pa-md">
                    <div class="text-body1 col-12 q-pl-md q-pb-md">{{live_class.description}}</div>
                    <div class="text-subtitle2 col-12 q-pl-md">{{ $t('live_class_start_schedule') }}: <strong>{{ fDateTime(live_class.date_class) }}H</strong></div>
                    <h5 v-if="$q.platform.is.mobile" class="text-h5 text-red"><strong>{{ $t('mobile_live_class_student_helper') }}</strong></h5>
                </q-card-main>

                <q-card-separator />

                <q-card-actions class="row justify-end q-pa-md">
                    <q-btn color="tertiary" class="col-5" :label="$t('back')" :icon="getIconBtn('back')" @click="closeModal" />
                    <q-btn color="primary" class="col-5" :label="$t('start')" :icon="getIconBtn(activity)" @click="live_class.platform_type === 1 ? gotoClass(live_class.live_class_id) : openMeeting(live_class)"  />
                </q-card-actions>
            </q-card>
        </div>


        <q-modal v-if="show_modal_class_room" v-model="show_modal_class_room" :content-css="{minWidth: '100vw', minHeight: '100vh'}" no-backdrop-dismiss no-esc-dismiss @hide="hideModalClassRoom">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideModalClassRoom()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ live_class.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <class-room v-if="show_modal_class_room" :room="code_room"  @hideModalClassRoom="hideModalClassRoom" />
            </q-modal-layout>
        </q-modal>

        <q-dialog
            v-model="show_meet_dialog"
            stack-buttons
            prevent-close
            @cancel="show_meet_dialog = false"
            @hide="show_meet_dialog = false"
        >
            <span slot="title">{{$t('window_blocked')}}</span>
            <span slot="message">
                {{ $t('browser_window_blocked_click') }}
                <a :href="live_class.embed" target="_blank" rel="noopener noreferrer">{{$t('here')}}</a>
                {{ $t('to_access_the_class')}}
                </span>
        </q-dialog>

    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import { db } from 'plugins/vuefire'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'


export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'admin', 'courses', 'presential', 'live_classes' ] },

    props: ['activity', 'event_date_id', 'presential_event_id'],

    data() {
        return {
            live_class: '',
            title: '',
            description: '',
            code_room: '',
            loading: false,
            show_modal_class_room: false,
            selected_live_class: {},
            show_meet_dialog: false,
            name: ''
        }
    },

    components: {
        'class-room': () => import('components/live_classes/ClassRoom.vue'),
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        async gotoClass() {
            try {
                this.$q.loading.show()
                const response = await this.$axios.get(`/etraining_presential/presential/${this.presential_event_id}/presential_event_date/${this.event_date_id}/open_class/`, this.getHeader)
                if (response.status === 200) {
                    this.selected_live_class = response.data
                    this.show_modal_class_room = true
                    this.setUserOnlineFirebase()
                }

            } catch (e) {
                this.$q.notify({
                    message: this.$t('live_class_not_available_yet_info'),
                    type: 'warning',
                    icon: 'far fa-clock',
                    position: 'bottom'
                })
                console.log(e)
            } finally {
                this.$q.loading.hide()
            }
        },

        openMeeting(live) {
            this.$axios.get(`/etraining_presential/presential/${this.presential_event_id}/presential_event_date/${this.event_date_id}/open_class/`, this.getHeader)
            .then(response => {
                if (response.status === 200) {
                    this.selected_live_class = response.data

                    let meet = window.open(live.embed, '_blank')
                    if (meet === null) {
                        this.show_meet_dialog = true
                    } else return
                }
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('live_class_not_available_yet_info'),
                    type: 'warning',
                    icon: 'far fa-clock',
                    position: 'bottom'
                })
                console.log(e)
            })
        },

        hideModalClassRoom() {
            this.show_modal_class_room = false
            this.setUserOfflineFirebase()
        },

        closeModal() {
            this.$emit('closeModal')
        },

        getIconBtn(activity) {
            if (activity.type_slug === 'live_class') return 'far fa-eye'
            else return 'fas fa-chevron-left'
        },

        setUserOnlineFirebase() {
            if (this.live_class.status != 4) {
                let { uid } = firebase.auth().currentUser
                let userStatus = firebase.database().ref(`/live_class_user_status/${this.live_class.live_class_id}/${uid}`)
                let userOnline = firebase.database().ref(`/live_class_user_online/${uid}`)

                let isOnlineForDatabase = {
                    st: 'on',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.live_class.live_class_id.toString())
                }

                let isOfflineForDatabase = {
                    st: 'off',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.live_class.live_class_id)
                }

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userStatus.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userStatus.set(isOnlineForDatabase)
                    })
                })

                firebase.database().ref('.info/connected').on('value', (snapshot) => {
                    userOnline.onDisconnect().set(isOfflineForDatabase).then(() => {
                        userOnline.set(isOnlineForDatabase)
                    })
                })
            }
        },

        setUserOfflineFirebase() {
            if (this.live_class.status != 4) {
                let { uid } = firebase.auth().currentUser
                let userStatus = firebase.database().ref(`/live_class_user_status/${this.live_class.live_class_id}/${uid}`)
                let userOnline = firebase.database().ref(`/live_class_user_online/${uid}`)

                let isOfflineForDatabase = {
                    st: 'off',
                    dt: firebase.database.ServerValue.TIMESTAMP,
                    we: parseInt(this.live_class.live_class_id)
                }

                userStatus.set(isOfflineForDatabase)
                userOnline.set(isOfflineForDatabase)
            }
        },

        fDateTime(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY - HH:mm'
                    break
                    default: format = 'MM-DD-YYYY - HH:mm'
                    break
                }

                return date.formatDate(d, format)
            }
        },
    },

    beforeDestroy () {
        if (this.show_modal_class_room) {
            this.setUserOfflineFirebase()
        }
    },

    beforeRouteLeave (to, from, next) {
        if (this.show_modal_class_room) {
            this.setUserOfflineFirebase()
        }
        next()
    },

    created() {
        this.live_class = this.activity
        this.code_room = this.activity.code_room
    },
}
</script>

<style>

</style>
